
// import { create } from 'apisauce'
import axios from 'axios'
import { getCookies, setCookiesWithExpire } from '@/utils/cookies'
/**
 * init class API
 * @param opt
 * @returns {CrmApi}
 * @constructor
 */
function CrmApi (opt) {
  if (!(this instanceof CrmApi)) {
    return new CrmApi(opt)
  }
  opt = opt || {}
  this.classVersion = '1.0.0'
  this.api = axios.create({
    baseURL: process.env.BASE_API,
    timeout: 9000000
  })
  this.apiPython = axios.create({
    baseURL: process.env.PYTHON_API,
    timeout: 9000000
  })
}
/**
 * Request to the server,
 * You fixed: https://gist.github.com/pranavrajs/66bccee3f8ba100742a1273db6f587af
 * @param url
 * @param callback
 * @returns {axios.Promise}
 * @private
 */
CrmApi.prototype._requestAuthPost = function (url, contentType, data, callback) {
  var headers = {
    Accept: 'application/json',
    'Authorization': 'Bearer 23432567654',
    'Content-Type': contentType
  }
  console.log(headers)
  return this.api.post(url, data, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  })
}
CrmApi.prototype._requestDataPost = function (url, contentType, data, callback) {
  var headers = {
    Accept: 'application/json',
    'Content-Type': contentType
  }
  var authToken = getCookies('authToken')
  if (authToken !== undefined) {
    setCookiesWithExpire('authToken', authToken, 3)
  }
  // this.api.defaults.headers.post.Authorization = 'Bearer e02e8466ccd8d9854680a11cb721f576nyOwJVcjyWAxEa6pI/uqRdlEgDBemwU+UtE1Il3QpSU='
  // console.log('this.api.defaults', this.api.defaults.headers.post)
  return this.api.post(url, data, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    if (error.message === 'Network Error') {
      error.message = 'Connection failed with SuperAdmin server, please check your internet connection'
    }
    return {
      success: 0,
      message: error.message
    }
  })
}
CrmApi.prototype._requestDataPostFileAttachment = function (url, contentType, data, callback) {
  var headers = {
    Accept: 'application/json',
    'Content-Type': contentType,
    responseType: 'blob'
  }
  return this.api.post(url, data, headers).then((response) => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    if (error.message === 'Network Error') {
      error.message = 'Connection failed with SuperAdmin server, please check your internet connection'
    }
    return {
      success: 0,
      message: error.message
    }
  })
}
CrmApi.prototype._requestDataGet = function (url, contentType, data, callback) {
  var headers = {
    Accept: 'application/json',
    'Content-Type': contentType
  }
  var param = ''
  if (data !== '') {
    param = '/' + data
  }
  console.log(param)
  return this.api.get(url + param, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    if (error.message === 'Network Error') {
      error.message = 'Connection failed with SuperAdmin server, please check your internet connection'
    }
    return {
      success: 0,
      message: error.message
    }
  })
}
CrmApi.prototype._requestFileDataGet = function (url, contentType, data, callback) {
  var headers = {
    responseType: 'arraybuffer'
  }
  var param = ''
  if (data !== '') {
    param = '/' + data
  }
  return this.api.get(url + param, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    return {
      success: 0,
      message: error.message
    }
  })
}
CrmApi.prototype._requestPythonDataPost = function (url, contentType, data, callback) {
  var headers = {
    Accept: 'application/json',
    'Content-Type': contentType
  }
  return this.apiPython.post(url, data, headers).then(response => {
    if (response.data) {
      if (typeof callback === 'function') {
        callback()
      }
      return response.data
    } else {
      return {
        success: 0,
        message: response.problem
      }
    }
  }).catch(error => {
    return {
      success: 0,
      message: error.message
    }
  })
}

// CrmApi.prototype.initApp = async function (data, callback) {
//   const requestUrl = 'api/v1/auth/initApp'
//   const contentType = 'application/x-www-form-urlencoded'
//   return this._requestDataPost(requestUrl, contentType, data, callback)
// }
CrmApi.prototype.login = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/auth/login'
  const contentType = 'application/json'
  data = JSON.stringify(data)
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.UserPermissionList = async function (data, callback) {
  const requestUrl = 'api/v1/auth/staffPermission'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.companyBasicInfo = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/company/companyBasicInfo'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.companyList = async function (data, callback) {
  const requestUrl = '/api/v1/superAdmin/company/companyList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.companystaffList = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/company/companyStaffList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.companyAppSetting = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/company/companyAppSetting'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.companyEmailConfigurationList = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/company/companyEmailConfigurationList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.companyThirdPartyIntegration = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/company/companyThirdPartyIntegration'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.CompanyStorageInfo = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/company/companyStorageInfo'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.companyDeviceList = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/company/companyDeviceList'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.dashboardBasicInfo = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/dashboard/dashboardBasicInfo'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.ResumeEmailReading = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/email/resumeEmailReading'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.emailConfigurationDetail = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/email/emailConfigDetail'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.appSettingDetail = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/setting/app/detail'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.saveAppSettingDetail = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/setting/app/save'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.addUserDetails = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/setting/user/add'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.userListing = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/setting/user/list'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.userDetail = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/setting/user/detail'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.userDetailUpdate = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/setting/user/update'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
CrmApi.prototype.userEmailValidate = async function (data, callback) {
  const requestUrl = 'api/v1/superAdmin/setting/user/userEmailValidate'
  const contentType = 'application/x-www-form-urlencoded'
  return this._requestDataPost(requestUrl, contentType, data, callback)
}
export default CrmApi



// WEBPACK FOOTER //
// ./src/api/CrmApi.js